import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSingleDevice, setPage, updateDevicesPageActiveTab, updateEchoOverviewPageSelectedDevice } from 'redux/actions';
import DeviceTypePageTemplate from '../../components/shared/DeviceTypePageTemplate/DeviceTypePageTemplate';
import { DEVICES_PAGE_TAB, Status, LOADING_CIRCLE } from 'common/utils/constants';
import { ReturnButton } from 'components/shared/ReturnButton/ReturnButton';
import CommissionErrorBox from 'components/features/Commissioning/CommissionErrorBox/CommissionErrorBox';
import './EchoOverviewPage.css';

const EchoOverviewPage = (props) => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const deviceId = searchParams.get('deviceId');
  const selectedDevice = useSelector((store) => store.ui.echoOverviewPage.selectedDevice);
  const [getDeviceError, setGetDeviceError] = useState(null);
  const [isInitialGetDeviceCalled, setIsInitialGetDeviceCalled] = useState(false);
  const mounted = useRef();
  const dispatch = useDispatch();
  const getDeviceStatus = useSelector((store) => store.statuses[`GET-${deviceId}`]);

  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      dispatch(
        getSingleDevice(deviceId, (result) => {
          setIsInitialGetDeviceCalled(true);
          if (result.message) {
            setGetDeviceError(result.message);
          } else {
            dispatch(updateEchoOverviewPageSelectedDevice(result));
          }
        })
      ); //do a single get device when single device page is loaded
      mounted.current = true;
      dispatch(setPage('EchoOverviewPage'));
    } else {
      // do componentDidUpdate logic
    }
  });

  let overlay = null;
  if (getDeviceError) {
    overlay = (
      <CommissionErrorBox
        title={`Get Device Error: ${getDeviceError}`}
        message={'Something went wrong. Please try again later.'}
        onClose={() => {
          setGetDeviceError(null);
          overlay = null;
        }}
      />
    );
  } else if (!isInitialGetDeviceCalled && getDeviceStatus === Status.PENDING) {
    overlay = (
      <div id="Global_LoadingCircle_Overlay" className="Global_LoadingCircle_Overlay">
        {LOADING_CIRCLE}
      </div>
    );
  }

  return (
    <div id="EchoOverviewPageContainer" className="EchoOverviewPageContainer">
      {overlay}
      <ReturnButton
        text={'Return to Echo 5G page'}
        route={'/console/devices'}
        action={() => {
          dispatch(updateDevicesPageActiveTab(DEVICES_PAGE_TAB.echo));
          dispatch(updateEchoOverviewPageSelectedDevice(null));
        }}
      />
      <DeviceTypePageTemplate deviceType={'echo'} device={selectedDevice} lastCommissionDate={-1}/>
    </div>
  );
};

export default EchoOverviewPage;
